module.exports = __webpack_public_path__ + "img/blockchain.7ae403a1.svg";